import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { SECONDS_IN_DAY } from 'helpers/datetime';
import { TREND_CHART_MARGIN } from '../../../constants';
import styles from './ScrollSelector.pcss';
const ScrollSelector = ({ start, end, visibleStart, setVisibleDay })=>{
    useStyles(styles);
    const dayLen = Math.ceil((end - start) / SECONDS_IN_DAY);
    const labelStep = Math.round(dayLen / 15) || 1;
    if (dayLen === 1) {
        return null;
    }
    const onSetVisibleDay = (evt)=>{
        const btn = evt.target;
        const dayNumber = btn.value;
        const newStart = start + SECONDS_IN_DAY * dayNumber;
        const newEnd = newStart + SECONDS_IN_DAY - 1;
        setVisibleDay(newStart, newEnd);
    };
    const renderTrackSegment = (dayNumber, idx)=>{
        const dayStart = start + SECONDS_IN_DAY * dayNumber;
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: cn(styles.trackSegment, {
                [styles['trackSegment--active']]: dayStart === visibleStart
            }),
            style: {
                width: `${100 / dayLen}%`
            },
            value: dayNumber,
            onClick: onSetVisibleDay,
            children: !(idx % labelStep) ? moment.unix(dayStart).utc().format('L').replace(/[./]?[0-9]{4}[./]?/, '') : ''
        }, dayNumber);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.track,
        style: {
            top: -(TREND_CHART_MARGIN.bottom / 2 + 16),
            marginLeft: TREND_CHART_MARGIN.left + 20,
            marginRight: TREND_CHART_MARGIN.right + 20
        },
        children: [
            ...Array(dayLen).keys()
        ].map(renderTrackSegment)
    });
};
export default ScrollSelector;
